export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5053.6c004b2b.jpg";